module.exports = __webpack_public_path__ + "static/img/logoone.8e48016.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logoone.png
// module id = 8l6z
// module chunks = 60